// extracted by mini-css-extract-plugin
export default {"wrapper":"LogsBar_wrapper__n-fS9","bar":"LogsBar_bar__KvLjy"};